const subZoneManagementPaths = {
  root: "/sub-zone-management",
};

export default subZoneManagementPaths;
